export default __webpack_public_path__ + "static/media/2maway.cb97fcbd.jpg";